import React from 'react';

import { NotificationPreferences } from './components';

// ─────────────────────────────────────────────────────────────────────

export const NotificationPreferencesLoading = (props: Props) => {
  const { title } = props;

  return (
    <NotificationPreferences.Container title={title}>
      <NotificationPreferences.Skeleton index={0} />

      <NotificationPreferences.Skeleton index={1} />
    </NotificationPreferences.Container>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  title: string;
};
